import React, {useMemo} from 'react'
import {Label} from '@therms/atalaya'
import {DateTime, UserName, UserNames} from '@therms/react-modules'
import {humanizeMinutes} from '@therms/web-js'
import dayjs from 'dayjs'
import {Timer} from '@src/components/Timer'

interface PatrolRouteRunInformationProps {
  description?: string
  endDate?: string
  startDate?: string
  startedByUserId?: string
  userIds?: string[]
}

function PatrolRouteRunInformation({
  description,
  endDate,
  startDate,
  startedByUserId,
  userIds,
}: PatrolRouteRunInformationProps) {
  const runDuration = useMemo(() => {
    if (!endDate) return ''
    return humanizeMinutes(dayjs(endDate).diff(startDate, 'minutes'))
  }, [endDate, startDate])

  const assistantIds = useMemo(() => {
    if (!Array.isArray(userIds)) return []
    return userIds.filter((userId) => userId !== startedByUserId)
  }, [userIds])

  return (
    <div className="gap-sm grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
      {!!description && (
        <div className="col-span-full">
          <Label>Description</Label>
          <p>{description}</p>
        </div>
      )}

      <div className="col-span-1">
        <Label>Started By</Label>
        <br />
        {startedByUserId ? (
          <UserName userId={startedByUserId} />
        ) : (
          <div className="text-color-subtle text-sm font-bold">N/A</div>
        )}
      </div>

      <div className="sm:col-span-2">
        <Label>Assisted By</Label>
        <br />
        {assistantIds.length ? (
          <UserNames userIds={assistantIds} />
        ) : (
          <div className="text-color-subtle text-sm font-bold">N/A</div>
        )}
      </div>

      <div className="col-span-1">
        <Label>Start Time</Label>
        <br />
        {startDate ? (
          <DateTime timestamp={startDate} />
        ) : (
          <div className="text-color-subtle text-sm font-bold">N/A</div>
        )}
      </div>

      <div className="col-span-1">
        <Label>End Time</Label>
        <br />
        {endDate ? (
          <DateTime timestamp={endDate} />
        ) : (
          <div className="text-color-subtle text-sm font-bold">N/A</div>
        )}
      </div>

      <div className="col-span-1">
        <Label>Run Duration</Label>
        <br />
        {runDuration || (
          <Timer
            className="font-mono"
            timestampStart={startDate}
            timestampEnd={endDate}
          />
        )}
      </div>
    </div>
  )
}

export {PatrolRouteRunInformation}
